import {
  Box,
  Icon,
  List,
  type MediumIcon,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  title: string
  onClick: () => void
  illustration: MediumIcon
  disabled?: boolean
}

const Item = ({ title, onClick, illustration, disabled }: Props) => {
  const [open, toggle] = useToggle(false)
  return (
    <List.ClickableItem navigateTo={onClick}>
      <Box flexDirection="row" alignItems="center" gap="s2">
        <Icon.Medium icon={illustration} color="iconPrimary" />
        <List.Title>{title}</List.Title>
      </Box>
      <Box
        padding="s2"
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'rel500',
        }}
      >
        <Tooltip.Alt
          attachment="bottom center"
          open={open}
          toggle={toggle}
          label={disabled ? i18n.t('compensations.compensations_product_disabled_tooltip') : ''}
        >
          <Icon.Medium icon="arrow-right" />
        </Tooltip.Alt>
      </Box>
    </List.ClickableItem>
  )
}

export default Item
